<mat-sidenav-container class="tw-h-full">
  <mat-sidenav
    *ngIf="!authService.palModeValue"
    #sidenav="matSidenav"
    [mode]="isSmallScreen ? 'over' : 'side'"
    [opened]="thinSidenavOpened"
    [disableClose]="!isSmallScreen"
    position="start"
    class="my-sidenav-thin tw-border-r tw-border-gray-700 tw-w-14 xl:tw-w-16">
    <div class="tw-flex tw-flex-col tw-h-full tw-bg-gray-950">
      <!-- Top section -->
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-flex-1 tw-pt-8">
        <div class="tw-flex tw-flex-col tw-items-center tw-gap-1">
          <button
            mat-icon-button
            class="tw-w-10 tw-h-10 xl:tw-w-12 xl:tw-h-12 !tw-p-0 tw-rounded-lg tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-800 tw-transition-colors"
            [routerLink]="'/chat'"
            routerLinkActive="tw-bg-teal-500 tw-bg-opacity-30"
            #rlaChat="routerLinkActive"
            matTooltip="Chat"
            matTooltipPosition="left"
            (click)="onNavButtonClick()">
            <mat-icon class="tw-text-[20px] tw-w-[20px] tw-h-[20px] tw-text-gray-400" [ngClass]="{'tw-text-white': rlaChat.isActive}"
              >question_answer
            </mat-icon>
          </button>

          <!-- Chat History sub-button -->
          <button
            mat-icon-button
            class="tw-w-8 tw-h-8 xl:tw-w-9 xl:tw-h-9 !tw-p-0 tw-rounded-lg tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-800 tw-transition-colors"
            matTooltip="Chat History"
            matTooltipPosition="left"
            (click)="openChatHistory()">
            <mat-icon class="tw-text-[16px] tw-w-[16px] tw-h-[16px] tw-text-gray-500 hover:tw-text-gray-300">
              history
            </mat-icon>
          </button>
        </div>

        <button
          mat-icon-button
          class="tw-w-10 tw-h-10 xl:tw-w-12 xl:tw-h-12 !tw-p-0 tw-rounded-lg tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-800 tw-transition-colors"
          [routerLink]="'/insights'"
          routerLinkActive="tw-bg-teal-500 tw-bg-opacity-30"
          #rlaInsights="routerLinkActive"
          matTooltip="Insights"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-[20px] tw-w-[20px] tw-h-[20px] tw-text-gray-400" [ngClass]="{'tw-text-white': rlaInsights.isActive}">
            insights
          </mat-icon>
        </button>

        <button
          mat-icon-button
          class="tw-w-10 tw-h-10 xl:tw-w-12 xl:tw-h-12 !tw-p-0 tw-rounded-lg tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-800 tw-transition-colors"
          routerLinkActive="tw-bg-teal-500 tw-bg-opacity-30"
          [routerLinkActiveOptions]="{ paths: 'subset', matrixParams: 'ignored', queryParams: 'ignored', fragment: 'ignored' }"
          #rlaPeople="routerLinkActive"
          [routerLink]="'/people'"
          matTooltip="People"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-[20px] tw-w-[20px] tw-h-[20px] tw-text-gray-400" [ngClass]="{'tw-text-white': rlaPeople.isActive}">
            people
          </mat-icon>
        </button>

        <!-- <button
          mat-icon-button
          class="tw-w-10 tw-h-10 xl:tw-w-12 xl:tw-h-12 tw-rounded-lg tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-800 tw-transition-colors"
          [routerLink]="'/posts'"
          routerLinkActive="tw-bg-teal-500 tw-bg-opacity-30"
          #rlaPosts="routerLinkActive"
          matTooltip="Posts"
          matTooltipPosition="left"
          (click)="onNavButtonClick()">
          <mat-icon class="tw-text-gray-400" [ngClass]="{'tw-text-white': rlaPosts.isActive}">
            newspaper
          </mat-icon>
        </button> -->
      </div>

      <!-- Bottom section -->
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-mt-auto tw-pb-6">
        <!-- plan + usage indicator (plan name badge with a usage-to-quota gauge) -->
        <app-chat-usage-indicator displayMode="sidebar"></app-chat-usage-indicator>

        <!-- help icon  -->
        <button
          mat-icon-button
          (click)="showIntercom()"
          class="tw-text-gray-800 dark:tw-text-gray-400 hover:tw-text-gray-700 dark:hover:tw-text-gray-300 tw-transition-colors"
          matTooltip="Get help"
          matTooltipPosition="left">
          <mat-icon>help_outline</mat-icon>
        </button>

        <!-- account menu -->
        <button
          mat-icon-button
          [matMenuTriggerFor]="accountMenu"
          class="tw-w-10 tw-h-10 xl:tw-w-12 xl:tw-h-12 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-gray-800 hover:tw-bg-gray-700 tw-transition-colors tw-text-gray-400 tw-font-semibold"
          matTooltip="Account"
          matTooltipPosition="left">
          <span *ngIf="userInitial" class="tw-text-lg">{{ userInitial }}</span>
          <mat-icon *ngIf="!userInitial" class="tw-text-gray-400">account_circle</mat-icon>
        </button>
        <mat-menu
          #accountMenu="matMenu"
          class="account-menu-popover tw-bg-gray-900 tw-text-gray-100 tw-w-80 tw-rounded-xl tw-shadow-lg tw-py-2 tw-border tw-border-solid tw-border-gray-600">
          <div class="tw-border-0 tw-border-solid tw-border-b tw-border-gray-600 tw-pb-2">
            <div class="tw-text-sm tw-font-medium tw-pl-4 tw-mb-2">
              {{ authService.getUserValue?.email }}
            </div>
            <div *ngIf="orgs.length > 1" mat-menu-item [matMenuTriggerFor]="orgsMenu">
              <div
                class="org-picker-menu-item tw-flex tw-items-center tw-gap-2 tw-mt-1 tw-cursor-pointer">
                <div
                  class="tw-bg-gray-800 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-bold">
                  <mat-icon class="tw-text-base tw-w-4 tw-h-5 tw-leading-5 tw-mr-0">
                    corporate_fare
                  </mat-icon>
                </div>
                <div>
                  <div class="tw-font-semibold tw-text-white tw-truncate tw-max-w-[180px]">{{ selectedOrg?.name }}</div>
                  <div
                    *ngIf="selectedOrg?.id"
                    class="tw-text-xs tw-text-gray-400 tw-flex tw-items-center tw-gap-1 tw-cursor-copy"
                    (click)="copyOrgId(selectedOrg.id, $event)">
                    <span class="font-code-pro">{{ selectedOrg.id }}</span>
                    <mat-icon class="tw-text-xs tw-w-3 tw-h-3 tw-leading-3">content_copy</mat-icon>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="orgs.length === 1"
              class="tw-flex tw-items-center tw-gap-2 tw-mt-1 tw-px-4 tw-py-2">
              <div
                class="tw-bg-gray-800 tw-rounded-full tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-text-lg tw-font-bold">
                <mat-icon class="tw-text-base tw-w-4 tw-h-5 tw-leading-5 tw-mr-0">
                  corporate_fare
                </mat-icon>
              </div>
              <div>
                <div class="tw-font-semibold tw-text-white tw-truncate tw-max-w-[180px]">{{ orgs[0].name }}</div>
                <div
                  class="tw-text-xs tw-text-gray-400 tw-flex tw-items-center tw-gap-1 tw-cursor-copy"
                  (click)="copyOrgId(orgs[0].id, $event)">
                  <span class="font-code-pro">{{ orgs[0].id }}</span>
                  <mat-icon class="tw-text-xs tw-w-3 tw-h-3 tw-leading-3">content_copy</mat-icon>
                </div>
              </div>
            </div>
          </div>
          <mat-menu
            #orgsMenu="matMenu"
            class="org-picker-menu tw-bg-gray-900 tw-text-gray-100 tw-rounded-xl tw-shadow-lg tw-border tw-border-solid tw-border-gray-600">
            <ng-container *ngFor="let org of orgs">
              <button mat-menu-item (click)="switchOrg(org.id)" class="tw-flex tw-items-center">
                <div class="tw-flex tw-items-center">
                  <mat-icon class="tw-text-base tw-mr-0">corporate_fare</mat-icon>
                  <span
                    class="tw-whitespace-nowrap tw-ellipsis tw-w-full tw-overflow-hidden tw-text-ellipsis"
                    >{{ org.name }}</span
                  >
                  <mat-icon
                    *ngIf="org.id === selectedOrg?.id"
                    class="tw-ml-2 tw-mb-1 tw-text-blue-500">
                    check
                  </mat-icon>
                </div>
              </button>
            </ng-container>
          </mat-menu>
          <button
            *ngIf="$isOrgAdmin | async"
            mat-menu-item
            [routerLink]="'/billing'"
            (click)="onNavButtonClick()">
            <span>Billing</span>
          </button>
          <button
            *ngIf="$isOrgAdmin | async"
            mat-menu-item
            [routerLink]="'/team'"
            (click)="onNavButtonClick()">
            <span>Team</span>
          </button>
          <button
            *ngIf="$isOrgAdmin | async"
            mat-menu-item
            [routerLink]="'/api-keys'"
            (click)="onNavButtonClick()">
            <span>API Keys</span>
          </button>
          <button mat-menu-item (click)="showIntercom()">
            <span>Help</span>
          </button>
          <button
            mat-menu-item
            (click)="authService.logOut()"
            class="tw-text-red-400 tw-border-0 tw-border-solid tw-border-t tw-border-gray-600">
            <span>Log out</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- Domain-move announcement: inline at the top of the content area only, so
         the rail keeps its full height. Hidden in embedded (PAL) mode like the
         rest of the chrome; sticky so it stays visible on pages that scroll. -->
    <app-wf-domain-move-banner *ngIf="!authService.palModeValue"></app-wf-domain-move-banner>
    <div id="main-content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-download-status-container></app-download-status-container>
<app-streams-subscribe-drawer></app-streams-subscribe-drawer>
